<template>
  <div
    class="loader"
    :class="{
      loader_active: loading,
      loader_fixed: height === 'fixed',
    }"
    :style="{ height: height !== 'fixed' ? `${height}px` : '0' }"
  >
    <div class="loader-overlay">
      <div class="loader-icon" :class="{ 'mb-25': label }">
        <font-awesome-icon :icon="icon" spin />
      </div>

      <div class="loader-label">{{ label }}</div>
    </div>
  </div>
</template>

<script>
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "c-loader",

  components: { FontAwesomeIcon },

  props: ["active", "label", "height"],

  data() {
    return {
      loading: this.active,
      icon: faSpinner,
    };
  },

  watch: {
    active() {
      this.loading = this.active;
    },
  },

  mounted() {
    if (!this.height) {
      const loader = document.querySelector(".loader-overlay");
      const { top } = loader.getBoundingClientRect();

      // eslint-disable-next-line no-restricted-globals
      const result = screen.availHeight - top - 140;

      loader.style.height = `${result}px`;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.loader {
  position: relative;
  height: 0;
  transition: 0.2s;
  opacity: 0;
  visibility: hidden;

  &_fixed {
    position: fixed;
    top: 0;
    right: 0;
    height: 100% !important;
    width: 100% !important;
    z-index: 1000;
    max-width: inherit;
  }

  &_fixed .loader-overlay {
    background: rgba(0, 0, 0, 0.8) !important;
  }

  &_fixed .loader-overlay .loader-label {
    color: white;
  }

  &-overlay {
    border: 1px solid $color-border-alt;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: $z-index-loader;
    background: white;
    position: absolute;
    top: 0;
    left: 0;
  }

  &_active {
    opacity: 1;
    visibility: visible;
  }

  &-icon {
    font-size: 40px;
    color: $pink;
  }

  &-label {
    color: $label;
    font-size: 15px;
  }
}
.mb-25 {
  margin-bottom: 25px;
}
</style>
